import React from "react";
import { useSelector } from "react-redux";
import { Box, Paper, Stack } from "@mui/material";
import { SessionVerificationAdmin } from "../Components/SessionManagement/SessionManagementAdmin";
import Header from "../Components/header/Header/Header";
import MiniDrawer from "../Components/sidebar/SideBar";
import Footer from "../Components/Footer/Footer";
import SideBarRedesign from "../Components/sidebar/SideBarRedesign";
import MobileView from "../Components/views/MobileView";
import DesktopView from "../Components/views/DesktopView";

const AdminLayout = ({ children }) => {
  //#region code
  const open = useSelector((state) => state.sideExpand.open);
  //#endregion
  return (
    <>
      <SessionVerificationAdmin />

      {/* {isMobile ? ( */}
      <MobileView>
        <Box>
          {" "}
          <SideBarRedesign />
        </Box>
      </MobileView>
      {/* ) : ( */}

      <DesktopView>
        <Box>
          {" "}
          <Header />
          <MiniDrawer />
        </Box>
      </DesktopView>
      {/* )} */}

      {/* {isMobile ? (
        <>
          {" "} */}
      <MobileView>
        <Box>
          {/* Adjust the Main component to account for the sidebar */}
          <Box
            sx={{
              flexGrow: 1,
              marginLeft: open ? "0px" : "0px", // Adjust based on sidebar state
              transition: "margin 0.2s ease", // Smooth transition
              padding: "3px", // Add padding to content
              minHeight: "77vh",
            }}
          >
            <Paper
              elevation={0}
              sx={{
                width: "100%",
                mt: 1,
                mx: 0,
                my: 0,
                //display: "flex",
                //flexDirection: "column",
                //justifyContent: "center",
                //alignItems: "center",
                px: 0,
                pt: 10,
                pb: 0,
              }}
            >
              {children}
            </Paper>
          </Box>
        </Box>
      </MobileView>
      {/* Full Width Footer */}
      {/* <Footer
            sx={{
              width: "100vw", // Full viewport width
              backgroundColor: "#f5f5f5", // Footer background color
              textAlign: "center", // Center the content inside the footer
              // py: 2, // Padding for spacing
            }}
          /> */}
      {/* </>
      ) : (
        <> */}
      <DesktopView>
        <Box
          sx={{
            marginLeft: {
              xs: 7,
              sm: 8,
            },
            ...(open && { marginLeft: 33 }),
            transition: "200ms",
            minHeight: "77vh", // This ensures the content takes up enough space
            //display: "flex",
            //flexDirection: "column", // Use flexbox to arrange child elements
            //justifyContent: "space-between", // Space out the content and footer
          }}
        >
          <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            //sx={{ flexGrow: 1 }} // Allow the Stack to grow and take available space
          >
            <Paper
              elevation={0}
              sx={{
                width: "100%",
                mx: 5,
                my: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
                px: 3,
                pt: 0,
                pb: 5,
              }}
            >
              {children}
            </Paper>
          </Stack>

          {/* Full Width Footer */}
          {/* <Footer
              sx={{
                position: "fixed", // Fixes the footer at the bottom
                bottom: 0, // Aligns the footer to the bottom
                left: 0, // Ensures the footer starts from the left edge
                width: "100vw", // Full viewport width
                backgroundColor: "#f5f5f5", // Footer background color
                textAlign: "center", // Center the content inside the footer
                py: 2, // Padding for spacing
                zIndex: 10, // Ensures it stays above other content
              }}
            /> */}
        </Box>
      </DesktopView>
      {/* </>
      )} */}
    </>
  );
};

export default AdminLayout;
